// import React from 'react'
// import Box from '@mui/material/Box'
// import Typography from '@mui/material/Typography'
// import Link from '@mui/material/Link'
// import useMediaQuery from '@mui/material/useMediaQuery'
// import { useTheme } from '@mui/material/styles'
// import "./Footer.css"

// const Footer = () => {
//   const theme = useTheme()
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

//   return (
//     <Box
//       component="footer"
//       sx={{
//         width: "100%",
//         bgcolor: "#222",
//         color: "#fff",
//         py: isMobile ? 3 : 5,
//         px: isMobile ? 2 : 3, // Reduced padding for desktop
//         mt: 6,
//         borderTopRightRadius: isMobile ? "90px" : "150px"
//       }}
//     >
//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: isMobile ? "column" : "row",
//           justifyContent: "space-between",
//           alignItems: isMobile ? "flex-start" : "center",
//           gap: isMobile ? 2 : 0,
//           maxWidth: isMobile ? "100%" : 900,
//           mx: "auto",
//         }}
//       >
//         {/* Brand and tagline */}
//         <Box sx={{ mb: isMobile ? 2 : 0 }}>
//           <Typography variant="h6" sx={{ fontWeight: "bold", letterSpacing: 1 }}>
//             SUBH BHARAT STUDY TOOL PVT LTD
//           </Typography>
//           <Typography variant="body2" sx={{ color: "#bbb", mt: 0.5 }}>
//             Empowering Careers, Connecting Talent
//           </Typography>
//         </Box>

//         {/* Links */}
//         <Box sx={{ display: "flex", flexDirection: isMobile ? "column" : "row", gap: 3 }}>
//           <Link href="/" underline="hover" color="#fff" sx={{ fontSize: isMobile ? "1rem" : "1.05rem" }}>
//             Home
//           </Link>
//           <Link href="/privacy" underline="hover" color="#fff" sx={{ fontSize: isMobile ? "1rem" : "1.05rem" }}>
//             Privacy Policy
//           </Link>
//           <Link href="/terms" underline="hover" color="#fff" sx={{ fontSize: isMobile ? "1rem" : "1.05rem" }}>
//             Terms & Conditions
//           </Link>
//           <Link href="/contact" underline="hover" color="#fff" sx={{ fontSize: isMobile ? "1rem" : "1.05rem" }}>
//             Contact
//           </Link>
//         </Box>
//       </Box>

//       {/* Divider */}
//       <Box sx={{ borderTop: "1px solid #444", my: isMobile ? 2 : 3 }} />

//       {/* Copyright */}
//       <Box sx={{ textAlign: isMobile ? "left" : "center" }}>
//         <Typography variant="body2" sx={{ color: "#bbb" }}>
//           &copy; {new Date().getFullYear()} SUBH BHARAT STUDY TOOL PVT LTD. All rights reserved.
//         </Typography>
//       </Box>
//     </Box>
//   )
// }

// export default Footer



import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import { NavLink } from 'react-router-dom'
import "./Footer.css"

const Footer = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Box
      component="footer"
      sx={{
        width: "100%",
        bgcolor: "#222",
        color: "#fff",
        py: isMobile ? 3 : 5,
        px: isMobile ? 2 : 3,
        mt: 6,
        borderTopRightRadius: isMobile ? "90px" : "150px",
        boxSizing:"border-box"
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          justifyContent: "space-between",
          alignItems: isMobile ? "flex-start" : "center",
          gap: isMobile ? 2 : 0,
          maxWidth: isMobile ? "100%" : 900,
          mx: "auto",
          
        }}
      >
        {/* Brand and tagline */}
        <Box sx={{ mb: isMobile ? 2 : 0 }}>
          <Typography variant="h6" sx={{ fontWeight: "bold", letterSpacing: 1 }}>
            SUBH BHARAT STUDY TOOL PVT LTD
          </Typography>
          <Typography variant="body2" sx={{ color: "#bbb", mt: 0.5 }}>
            Empowering Careers, Connecting Talent
          </Typography>
        </Box>

        {/* Links */}
        <Box sx={{ display: "flex", flexDirection: isMobile ? "column" : "row", gap: 3 }}>
          <Link component={NavLink} to="/" underline="hover" color="#fff" sx={{ fontSize: isMobile ? "1rem" : "1.05rem" }} onClick={() =>window.scrollTo(0,0) }>
            Home
          </Link>
          <Link component={NavLink} to="/privacy&policy" underline="hover" color="#fff" sx={{ fontSize: isMobile ? "1rem" : "1.05rem" }} onClick={() =>window.scrollTo(0,0) }>
            Privacy Policy
          </Link>
          <Link component={NavLink} to="/terms&conditions" underline="hover" color="#fff" sx={{ fontSize: isMobile ? "1rem" : "1.05rem" }} onClick={() =>window.scrollTo(0,0) }>
            Terms & Conditions
          </Link>
          <Link component={NavLink} to="/contact" underline="hover" color="#fff" sx={{ fontSize: isMobile ? "1rem" : "1.05rem" }} onClick={() =>window.scrollTo(0,0) }>
            Contact
          </Link>
        </Box>
      </Box>

      {/* Divider */}
      <Box sx={{ borderTop: "1px solid #444", my: isMobile ? 2 : 3 }} />

      {/* Copyright */}
      <Box sx={{ textAlign: isMobile ? "left" : "center" }}>
        <Typography variant="body2" sx={{ color: "#bbb" }}>
          &copy; {new Date().getFullYear()} SUBH BHARAT STUDY TOOL PVT LTD. All rights reserved.
        </Typography>
      </Box>
    </Box>
  )
}

export default Footer